import React from "react"

function CTAC() {
  return (
    <svg fill="none" viewBox="0 0 266 150">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <rect
        x={90}
        y={48}
        width={86}
        height={5}
        rx={2.5}
        fill="var(--solid-900)"
      />
      <rect
        x={80}
        y={57}
        width={106}
        height={4}
        rx={2}
        fill="var(--base-500)"
      />
      <rect x={85} y={65} width={97} height={4} rx={2} fill="var(--base-500)" />
      <rect
        x={183}
        y={92}
        width={44}
        height={10}
        rx={2}
        fill="var(--main-500)"
      />
      <rect
        x={111}
        y={92}
        width={66}
        height={10}
        rx={2}
        fill="var(--base-400)"
      />
      <rect
        x={39}
        y={92}
        width={66}
        height={10}
        rx={2}
        fill="var(--base-400)"
      />
    </svg>
  )
}

export default CTAC
